import React from "react";
import { auth, db } from "../../fire";
import { userContext } from "../../Context/user";
import { Login } from "../../Views/Login";

export class ProtectedRoutes extends React.Component {
  state = {
    user: null,
    loading: true
  };

  componentDidMount() {
    auth.onAuthStateChanged(async user => {
      if (!user) {
        return this.setState({ loading: false });
      }
      const userRef = await db
        .collection("users")
        .doc(user.uid)
        .get();

      const userData = {
        id: userRef.id,
        ...userRef.data()
      };

      if (!userData || !userData.prestadorDeServico) {
        this.setState({
          loading: false
        });
        return auth.signOut();
      }

      return this.setState({
        user: userData,
        loading: false
      });
    });
  }

  render() {
    const { user, loading } = this.state;

    if (loading) return null;

    if (!user) return <Login />;

    return (
      <userContext.Provider value={{ user }}>
        {this.props.children}
      </userContext.Provider>
    );
  }
}
